<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.5 7.74797V23C4.5 24.6569 5.84315 26 7.5 26H24.5C26.1569 26 27.5 24.6569 27.5 23V12.252C27.5 10.5952 26.1569 9.25203 24.5 9.25203H6.12602C5.22799 9.25203 4.5 8.52404 4.5 7.62602V7.62602C4.5 6.72799 5.22799 6 6.12602 6H19.7604C21.4173 6 22.7604 7.34315 22.7604 9V9.15549"
        stroke="black" />
    <path
        d="M27.5 15.1158H22.8918C21.5363 15.1158 20.4375 16.2147 20.4375 17.5701V17.5701C20.4375 18.9256 21.5363 20.0244 22.8918 20.0244H27.5"
        stroke="black" />
</svg>
